(function($, undefined) {
	
	'use strict';
//    var profile = Fw.component.models().profile;
	var currPage;
    
	var init = function (page) {
		currPage = $(page);
        
//        profile.init(page);
	};
	
    
    
   	
	$(window).on("load",function(){
        init();
    });
	
})(jQuery);